import React, { createContext, useContext, useState, useEffect } from 'react';

// Contexto para compartir código entre la documentación y el playground
const PlaygroundContext = createContext();

// Key para localStorage
const PLAYGROUND_CODE_KEY = 'blox_playground_code';

export const PlaygroundProvider = ({ children }) => {
  const [playgroundCode, setPlaygroundCode] = useState(null);

  // Al montar, verificar si hay código pendiente en localStorage
  useEffect(() => {
    const savedCode = localStorage.getItem(PLAYGROUND_CODE_KEY);
    if (savedCode) {
      setPlaygroundCode(savedCode);
    }
    // Efecto de montaje único; PLAYGROUND_CODE_KEY es constante del módulo.
  }, []);

  // Función para establecer el código que se llevará al playground
  const sendToPlayground = (code) => {
    // Guardar en localStorage para persistir entre navegaciones
    localStorage.setItem(PLAYGROUND_CODE_KEY, code);
    setPlaygroundCode(code);
  };

  // Función para limpiar el código del contexto después de usarlo
  const clearPlaygroundCode = () => {
    localStorage.removeItem(PLAYGROUND_CODE_KEY);
    setPlaygroundCode(null);
  };

  return (
    <PlaygroundContext.Provider value={{ 
      playgroundCode, 
      sendToPlayground, 
      clearPlaygroundCode 
    }}>
      {children}
    </PlaygroundContext.Provider>
  );
};

// Hook personalizado para usar el contexto
export const usePlayground = () => {
  const context = useContext(PlaygroundContext);
  if (!context) {
    throw new Error('usePlayground debe usarse dentro de PlaygroundProvider');
  }
  return context;
};

export default PlaygroundContext;
